var map = {
	"./austria.png": "VI1U",
	"./belgium.png": "Z3/h",
	"./danmark.png": "VKCD",
	"./england.png": "tl7k",
	"./finland.png": "FwPZ",
	"./france.png": "Fz4B",
	"./germany.png": "9wjN",
	"./hong-kong.png": "d313",
	"./italy.png": "CLHf",
	"./lithuania.png": "OqCR",
	"./luxembourg.png": "B9hM",
	"./monaco.png": "xpd/",
	"./netherlands.png": "xAHi",
	"./norway.png": "chQJ",
	"./poland.png": "GW3p",
	"./portugal.png": "18fV",
	"./singapore.png": "X3Hu",
	"./spain.png": "qt2h",
	"./sweden.png": "oYSv",
	"./switzerland.png": "Iagk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tCP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countries ^\.\/.*$
// module id = /tCP
// module chunks = 0